import React, { useState } from "react";
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Divider,
  Tabs,
  Tab,
  Box,
  colors,
} from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import DataUsageIcon from "@material-ui/icons/DataUsage";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Page from "src/components/Page";
import { LanguageSection } from "./languageSection";
import { loadUser } from "src/redux/actions";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { ReportSection } from "./reportSection";
import TabPanel from "src/components/tabPanel";
import ThemeChange from "src/layouts/DashboardLayout/themeChange";
import SampleSizeSection from "./sampleSizeSection";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(8),
    background: "inherit",
  },
  pageTitle: {
    marginBottom: theme.spacing(3),
    fontWeight: 300,
    color: colors.grey[800],
  },
  sectionTitle: {
    marginBottom: "5px",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  sectionDivider: {
    marginTop: "25px",
    width: "100%",
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));

function mapDispatchToProps(dispatch) {
  return {
    loadUser: () => dispatch(loadUser()),
  };
}

const mapStateToProps = (state) => {
  return { userObject: state.userObject, appConf: state.appConf };
};

const ConnectedSettingsPage = (props) => {
  const classes = useStyles();
  const { loadUser, userObject, appConf } = props;
  const [tabValue, setTabValue] = useState(0);
  // const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  // const theme = useSelector((state) => state.theme);
  // const dispatch = useDispatch();
  // const handleTheme = () => {
  //   dispatch(updateTheme(theme === "light" ? "dark" : "light"));
  // };

  return (
    <Page className={classes.root} title={t("Dashboard Settings")}>
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              className={classes.pageTitle}
              component="h3"
              variant="h3"
            >
              {t("Dashboard Settings")}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Tabs
              indicatorColor="primary"
              orientation="vertical"
              value={tabValue}
              onChange={handleChangeTab}
              aria-label="Settings main tabs"
              sx={{ borderRight: 1, borderColor: "divider" }}
            >
              <Tab
                label={
                  <Box className={classes.tabLabel}>
                    <HomeWorkIcon style={{ fontSize: "21px" }} />
                    <span>{t("General")}</span>
                  </Box>
                }
              />
              <Tab
                label={
                  <Box className={classes.tabLabel}>
                    <SettingsApplicationsIcon style={{ fontSize: "21px" }} />
                    <span>{t("Advanced")}</span>
                  </Box>
                }
              />
            </Tabs>
          </Grid>
          <Grid item xs={10}>
            <TabPanel value={tabValue} index={0}>
              <Typography
                variant="h3"
                component="h3"
                style={{
                  marginBottom: "30px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <HomeWorkIcon style={{ fontSize: "26px" }} /> {t("General")}
              </Typography>
              <Grid item xs={12}>
                <Typography
                  component="h2"
                  variant="h4"
                  className={classes.sectionTitle}
                >
                  <LanguageIcon style={{ fontSize: "21px" }} /> {t("Language")}
                </Typography>
                <Typography>
                  {t("Choose the default dashboard language")}
                </Typography>
                <LanguageSection loadUser={loadUser} userObject={userObject} />
              </Grid>
              <Divider className={classes.sectionDivider} />
              {/* <Grid item xs={12} style={{ paddingTop: "20px" }}>
              <Typography
                component="h2"
                variant="h3"
                className={classes.sectionTitle}
              >
                {t("Search")}
              </Typography>
              <Typography>
                {t("Choose which sections you want to view when using search")}
              </Typography>
              <SearchSection loadUser={loadUser} userObject={userObject} />
            </Grid> */}
              <Grid item xs={12} style={{ paddingTop: "20px" }}>
                <Typography
                  component="h2"
                  variant="h4"
                  className={classes.sectionTitle}
                >
                  <DataUsageIcon style={{ fontSize: "21px" }} />{" "}
                  {t("Sample Size")}
                </Typography>
                <Typography>
                  {t("Choose the default sample size for your tables")}
                </Typography>
                <SampleSizeSection
                  loadUser={loadUser}
                  userObject={userObject}
                />
              </Grid>
              <Divider className={classes.sectionDivider} />
              <Box
                paddingTop="20px"
                display="flex"
                flexDirection="column"
                justifyContent="start"
                alignItems="start"
              >
                <Typography
                  component="h2"
                  variant="h4"
                  className={classes.sectionTitle}
                >
                  <Brightness4Icon style={{ fontSize: "21px" }} />{" "}
                  {t("Change theme")}
                </Typography>
                <Typography>
                  {t("Choose the default dashboard theme")}
                </Typography>
                <ThemeChange />
              </Box>
            </TabPanel>
            <Grid item xs={12}>
              <TabPanel value={tabValue} index={1}>
                <ReportSection
                  userObject={userObject}
                  loadUser={loadUser}
                  appConf={appConf}
                />
              </TabPanel>
            </Grid>
          </Grid>
          {/* <Divider className={classes.sectionDivider} /> */}
        </Grid>
      </Container>
    </Page>
  );
  // }
};

export const SettingsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSettingsPage);
